import { Theme, createTheme } from '@mui/material/styles'

import breakpoints from './breakpoints'
import hover from './hover'
import motion from './motion'
import componentsOverride from './overrides'
import palette from './palette'
import radii from './radii'
import shadows, { customShadows } from './shadows'
import typography from './typography'

// ----------------------------------------------------------------------
// The one place the application theme is assembled.
//
// The app and the test renderer both call this, so a component under test
// resolves exactly the values it resolves in the browser. A second, slightly
// different theme built somewhere else is how a design system starts lying.
// ----------------------------------------------------------------------

/**
 * MUI multiplies `sx={{ borderRadius: n }}` by this value, which is how the app
 * grew five radii that sit on no ramp. It is frozen at the vendor template's
 * number so any shorthand still in the app keeps rendering what it rendered
 * before; new code asks for `theme.radii.inline | control | surface | pill`,
 * which are CSS lengths and are not multiplied.
 */
export const LEGACY_SX_RADIUS_UNIT = 8

export type ThemeMode = 'light' | 'dark'

export const createAppTheme = (mode: ThemeMode): Theme => {
  const isLight = mode === 'light'

  const theme = createTheme({
    palette: isLight ? palette.light : palette.dark,
    typography,
    breakpoints,
    shape: { borderRadius: LEGACY_SX_RADIUS_UNIT },
    radii,
    motion,
    hover: isLight ? hover.light : hover.dark,
    direction: 'ltr',
    shadows: isLight ? shadows.light : shadows.dark,
    customShadows: isLight ? customShadows.light : customShadows.dark,
  })

  theme.components = componentsOverride(theme)
  return theme
}
